module.exports = __webpack_public_path__ + "img/unmuted.a6e12915.svg";